import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { PrivaDialogButton, PrivaDialogComponent } from '@priva/components/dialog-simple';
import { PrivaLocalizationModule } from '@priva/localization';

import { Activity } from 'app/shared/features/activity-selector/models';
import { closeDialog } from 'app/state/app-state/app-state.actions';
import { breakEnding } from 'app/state/break/break.actions';

import { SubtitlePipe } from './break-dialog-subtitle.pipe';

@Component({
    selector: 'app-row-status-select-dialog',
    templateUrl: './break-dialog.component.html',
    styleUrl: './break-dialog.component.scss',
    imports: [PrivaDialogComponent, PrivaLocalizationModule, SubtitlePipe],
})
export class BreakDialogComponent {
    private store = inject(Store);

    title = 'DIALOG.BREAK.TITLE';
    activity: Activity | undefined = undefined;
    buttons: PrivaDialogButton[] = [
        {
            id: 'continue',
            importance: 'primary',
            icon: 'fas fa-play',
            text: 'DIALOG.BREAK.ACTION',
            iconState: 'left',
        },
    ];

    doNothing() {
        // used to override standard behavior of priva dialog
    }

    endBreak() {
        this.store.dispatch(closeDialog());
        this.store.dispatch(breakEnding({ endTimestamp: Date.now() }));
    }
}
